import { useEffect } from 'react';

import { PreloadedQuery } from 'react-relay';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import { ProductKeys } from '@atlassiansox/asc-stargate';

import { pricingPageRelayQuery } from '@/__generated_contentful__/pricingPageRelayQuery.graphql';
import { CrossFlowTouchpointProvider } from '@/components/cross-flow/touchpoint/context';
import { PricingContentContextProviderRelay } from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { IntercomProvider } from '@/libraries/intercom/src/provider';
import { ConfluencePricingPageV2Template } from '@/templates/software/confluence/pricing/src/confluence-pricing-page-v2.template';
import { experiments } from '@/utils/experiment/manifest';
import { useExperimentExposure } from '@/utils/experiment/use-experiment-exposure';
import { PricingContent } from '@/utils/pricing-queries/get-pricing-content-gql';

import { AppPricingData } from '../../../../contentful/product-catalog';
import { UserLocale } from '../../../../utils/useGeoCurrency';

export type ConfluencePricingPageProps = {
	pricing?: AppPricingData;
	countryCode?: UserLocale;
	pricingContent?: PricingContent;
	queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const ConfluencePricingPage = ({
	pricing,
	countryCode,
	pricingContent,
	queryRef,
}: ConfluencePricingPageProps) => {
	// FYI, this is currently JA only, since we only have JA work space appId
	const isBootIntercom: boolean = FeatureGates.checkGate('gwp-737-enable-intercom-chat-confluence');

	const [hasFired, fireExposure] = useExperimentExposure(
		experiments.confluencePricingPageWaeMigration,
	);
	useEffect(() => {
		if (!hasFired) {
			fireExposure();
		}
	}, [hasFired, fireExposure]);

	return (
		<IntercomProvider appId={'p0ww63i2'} triggerBoot={isBootIntercom}>
			<CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
				<PricingContentContextProviderRelay
					productId="confluence"
					pricingContent={pricingContent}
					queryRef={queryRef}
				>
					<ConfluencePricingPageV2Template pricing={pricing} countryCode={countryCode} />
				</PricingContentContextProviderRelay>
			</CrossFlowTouchpointProvider>
		</IntercomProvider>
	);
};
